<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Cotação Fretes Movimento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect},
  setup() {

  },
  data() {
    return {

      tempoCotaInt: 0,
      tempoCotaBraspres: 0,
      tempoCotaCorreios: 0,
      tempoCotaSSW: 0,
      tempoCotaAzulCargo: 0,

      showCotarAzulCargo: false,
      selectedAzulCargoService: 'ECOMM',
      selectedTipoEntregaAzul: 'DOMICILIO',
      selectedColetaAzul: 'SIM',
      serviceAzulCargoOptions: [
        'PREMIUM',
        'PREMIUM_CORP',
        'EXPRESSO',
        'EXPRESSO_CORP',
        'ECOMM',
        'ECOMM_CORP',
        'STANDARD',
        'STANDARD_CORP',
      ],
      tipoEntregaAzul: [
          'DOMICILIO',
          'AEROPORTO'
      ],

      showModalCotarCorreios: false,
      dtListPesqCorreioServico: null,
      submittedCotarCorreios: false,

      updating: true,
      errosValid: null,
      movData: {
        id: 0,
        status: 'A'
      },
      idData: 0,
      submitted: false,
      remetData: {},
      destData: {},
      freteCotaInterData: {},
      freteCotaBraspData: {},
      freteCotaCorreiosData: {},
      freteCotaSSWData: {},
      freteCotaAzulData: {},
      exibirTodos: 'S',
      paramTxAgenda: 'N',

      title: "Cotação Fretes Movimento",
      items: [
        {
          text: "Movimentos",
          href: "/movimentos/listnova",
        },
        {
          text: "Cotação Fretes Movimento",
          active: true,
        },
      ],



    };
  },

  watch: {
    'movData.altura': {
      handler() {
        this.calculaTotalHeader()
      }
    },
    'movData.largura': {
      handler() {
        this.calculaTotalHeader()
      }
    },
    'movData.comprimento': {
      handler() {
        this.calculaTotalHeader()
      }
    },
  },

  methods: {
    cotarAzulCargo(){
      console.log('---------------')
      const tempoIni = new Date().getTime()
      this.movData['servicoAzul'] = this.selectedAzulCargoService
      this.movData['tipoEntregaAzul'] = this.selectedTipoEntregaAzul
      this.movData['indicadorColetaAzul'] = this.selectedColetaAzul

      if (this.movData.peso && this.movData.valorliq && this.movData.altura && this.movData.altura
          && this.movData.largura && this.movData.comprimento && this.movData.ftcub) {

        api.post(`${getBaseUrl()}api/movcotarazulcargo`, {
          movData: this.movData
        }).then((res) => {
          this.showCotarAzulCargo = false
          console.log('then axios movcotarazulcargo')
          let data = res.data
          console.log('data')
          console.log(data)

          if (data.success) {
            this.freteCotaAzulData = res.data.list_azulcargo
            console.log(this.freteCotaAzulData)
            let tempoFim = new Date().getTime();
            this.tempoCotaAzulCargo = (tempoFim - tempoIni) / 1000;
            this.showCotarAzulCargo = false
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: data.message,
              showConfirmButton: false,
              timer: 2000
            })
          }
          this.updating = false
        }).catch((error) => {
          console.error('Erro na chamada API:', error);
        });
      }
    },

    abrirBase(idData){
      console.log('abrirBase')
      const routeData = this.$router.resolve(`/cotacaofretesbase/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    pesqCorreioServico(evt){
      console.log('pesqCorreioServico')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/corservpesq`, {
          params: { q: query, emp: this.movData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCorreioServico = res.data
        })
      }
    },


    mudouParamTxAgenda(){
      console.log('mudouParamTxAgenda')
      this.cotarFrete()


    },

    abreCadBase(){
      console.log('abreCadBase')

      const routeData = this.$router.resolve(`/cotacaofretesbase/list`)
      window.open(routeData.href, '_blank')
    },

    filtrarApenasValor(arrayEntr){
      // console.log('filtrarApenasValor')
      // console.log(arrayEntr)
      let arrResult = []
      arrayEntr.forEach((value) => {
        if (this.exibirTodos === 'S' || (this.exibirTodos ===  'N' && value.valor !== 0)){
          arrResult.push(value)
        }
      })
      return arrResult
    },

    calculaTotalHeader() {
      console.log('calculaTotalHeader')
      this.movData.pesocub = ((this.movData.altura * this.movData.largura * this.movData.comprimento) / 1000000).toFixed(4)
      this.freteCotaInterData = {}
    },


    cotarFrete(){
      console.log('cotarFrete')
      console.log(this.movData.altura)
      const tempoIni = new Date().getTime()
      this.submitted = true
      if (this.movData.peso && this.movData.valorliq && this.movData.altura && this.movData.altura
          && this.movData.largura && this.movData.comprimento && this.movData.ftcub) {
        this.updating = true
        api.get(`${getBaseUrl()}api/movcotaintercota`, {
          params: {
            iddata: this.idData,
            exibTodos: this.exibirTodos,
            paramTxAgenda: this.paramTxAgenda,
            movData: this.movData
          }
        }).then((res) => {
          console.log('then axios mov_cotar_interno')
          // console.log(res.data)
          // console.log('res.data[0]')
          // console.log(Array.isArray(res.data[0]))
          if (Array.isArray(res.data[0]) === false) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: res.data[0],
              showConfirmButton: false,
              timer: 2000
            })
          } else {
            this.freteCotaInterData = res.data[0]
            let tempoFim = new Date().getTime();
            this.tempoCotaInt = (tempoFim - tempoIni) / 1000;
          }
          this.updating = false
        });
      }
    },

    cotarBraspres(){
      console.log('cotarBraspres')
      console.log(this.movData.altura)
      const tempoIni = new Date().getTime()
      this.submitted = true
      if (this.movData.peso && this.movData.valorliq && this.movData.altura && this.movData.altura
          && this.movData.largura && this.movData.comprimento && this.movData.ftcub) {
        this.updating = true
        api.get(`${getBaseUrl()}api/movcotabrapres`, {
          params: {
            iddata: this.idData,
            movData: this.movData
          }
        }).then((res) => {
          console.log('then axios mov_cotar_braspres')
          console.log(res.data[0])
          if (res.data[0][0].id) {
            this.freteCotaBraspData = res.data[0]
            let tempoFim = new Date().getTime();
            this.tempoCotaBraspres = (tempoFim - tempoIni) / 1000;
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: 'Erro Retorno Braspress',
              text: res.data[0],
              showConfirmButton: false,
              timer: 2000
            })
          }
          this.updating = false
        });
      }
    },

    cotarSSW(){
      console.log('cotarSSW')
      console.log(this.movData.altura)
      const tempoIni = new Date().getTime()
      this.submitted = true
      if (this.movData.peso && this.movData.valorliq && this.movData.altura && this.movData.altura
          && this.movData.largura && this.movData.comprimento && this.movData.ftcub) {
        this.updating = true
        api.get(`${getBaseUrl()}api/movcotassw`, {
          params: {
            iddata: this.idData,
            movData: this.movData
          }
        }).then((res) => {
          console.log('then axios mov_cotar_ssw')
          console.log(res.data[0][1].length)
          if (res.data[0][0][0].id) {
            this.freteCotaSSWData = res.data[0][0]
            let tempoFim = new Date().getTime();
            this.tempoCotaSSW = (tempoFim - tempoIni) / 1000;
          }
          if (res.data[0][1].length > 0) {
            Swal.fire({
              position: "center",
              icon: "warning",
              title: `Inconsistência(s) na Resposta`,
              html: res.data[0][1],
              showConfirmButton: true,
              confirmButtonText: "Ok",
            })
          }
          this.updating = false
        });
      }
    },



    cotarCorreios(){
      console.log('cotarCorreios')
      console.log(this.movData.altura)
      const tempoIni = new Date().getTime()
      this.submittedCotarCorreios = true
      if (this.movData.peso && this.movData.valorliq && this.movData.altura && this.movData.altura
          && this.movData.largura && this.movData.comprimento && this.movData.ftcub &&
          this.movData.servcorreios && this.movData.prevpost
      ) {
        this.showModalCotarCorreios = false
        this.updating = true
        api.get(`${getBaseUrl()}api/movcotacorreios`, {
          params: {
            iddata: this.idData,
            movData: this.movData
          }
        }).then((res) => {
          console.log('then axios mov_cotar_correios')
          console.log(res.data[0][0])
          if (res.data[0][0].id) {
            this.freteCotaCorreiosData = res.data[0]
            let tempoFim = new Date().getTime();
            this.tempoCotaCorreios = (tempoFim - tempoIni) / 1000;
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: 'Erro Retorno Correios',
              text: res.data[0],
              showConfirmButton: false,
              timer: 2000
            })
          }
          this.updating = false
        });
      }
    },


    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/movcotainter`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios mov_cotar_interno')
        console.log(res.data)
        this.movData = res.data[0]
        this.remetData = res.data[1]
        this.destData = res.data[2]


        if (!this.movData.peso) {
          this.movData.peso = 1
        }

        if (!this.movData.altura) {
          this.movData.altura = 10
        }

        if (!this.movData.largura) {
          this.movData.largura = 20
        }

        if (!this.movData.comprimento) {
          this.movData.comprimento = 30
        }

        if (!this.movData.ftcub) {
          this.movData.ftcub = 300
        }


        this.idData = this.movData.id
        this.title = `Cotação Fretes Movimento (${this.movData.id})`
        this.updating = false
      });
    },


    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateMaisPrazo(value, prazo) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).add(prazo, 'days') .format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimalQuatro(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4, maximumFractionDigits: 4});
      }
      return "0,00";
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_movimento_cotacao_interna_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Nova Cotação Interna`
      this.updating = false
    }
  },


};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-success" class="mx-2" @click="cotarFrete">
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                Cotação Interna ({{ formatDecimal(tempoCotaInt) }})
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="cotarBraspres">
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                Cotação Braspress ({{ formatDecimal(tempoCotaBraspres) }})
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="showModalCotarCorreios = true">
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                Cotação Correios ({{ formatDecimal(tempoCotaCorreios) }})
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="cotarSSW">
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                Cotação SSW ({{ formatDecimal(tempoCotaSSW) }})
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="showCotarAzulCargo = true">
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                Cotação Azul Cargo ({{ formatDecimal(tempoCotaAzulCargo) }})
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="abreCadBase">
                <i class="bx bx-list-check font-size-16 align-middle me-2" ></i>
                Cadastro de Bases
              </b-button>

              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                </div>
              </div>



              <div class="col-sm-6">
                <div class="mb-3 align-items-end align-content-end float-end">
                  <h5 class="font-size-14">{{ exibirTodos === 'S' ? 'Exibir Todos' : 'Apenas com Valor' }}</h5>
                  <b-form-checkbox switch size="lg" value="S" unchecked-value="N" v-model="exibirTodos">

                  </b-form-checkbox>
                </div>
              </div>

<!--              <b-button variant="outline-warning" class="mx-2" @click="novaNota">-->
<!--                <i class="bx bx-box font-size-16 align-middle me-2" ></i>-->
<!--                Nova Faixa de Nota-->
<!--              </b-button>-->


<!--              <b-button variant="outline-warning" class="mx-2" @click="novaExtra">-->
<!--                <i class="bx bx-box font-size-16 align-middle me-2" ></i>-->
<!--                Nova Taxa Extra-->
<!--              </b-button>-->



            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <form class="needs-validation" @submit.prevent="formSubmit">
          <div class="card">
            <div class="card-body">

              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-999
                     class="text-dark"
                     href="javascript: void(0);">
                    Dados Nota Fiscal / Cálculo</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-999" visible accordion="my-accordion-999" role="tabpanel">
                <b-card-body>


                  <div class="row mb-2">

                    <div class="col-md-2">
                      <label for="codigo">Número</label>
                      <div class="position-relative">
                        <input
                            id="codigo"
                            type="text"
                            v-model="movData.codigo"
                            :disabled = true
                            class="form-control text-end"
                            placeholder="Número"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <label for="cidadedest">Cidade Destino</label>
                      <div class="position-relative">
                        <input
                            id="cidadedest"
                            type="text"
                            v-model="destData.cidade"
                            :disabled = true
                            class="form-control"
                            placeholder="Cidade Destino"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="estadodest">Estado</label>
                      <div class="position-relative">
                        <input
                            id="estadodest"
                            type="text"
                            v-model="destData.estado"
                            :disabled = true
                            class="form-control"
                            placeholder="Estado"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="cepdest">CEP Destino</label>
                      <div class="position-relative">
                        <input
                            id="cepdest"
                            type="text"
                            v-model="destData.cep"
                            :disabled = true
                            class="form-control"
                            placeholder="CEP Destino"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="nomedest">Nome Destino</label>
                      <div class="position-relative">
                        <input
                            id="nomedest"
                            type="text"
                            v-model="destData.nome"
                            :disabled = true
                            class="form-control"
                            placeholder="Nome Destino"/>
                      </div>
                    </div>

                  </div>


                  <div class="row mb-2">


                    <div class="col-md-2">
                      <label for="peso">Peso</label>
                      <div class="position-relative">
                        <input
                            id="peso"
                            type="number"
                            v-model="movData.peso"
                            class="form-control text-end"
                            :class="{'is-invalid': submitted && !movData.peso}"
                            placeholder="Peso"/>
                        <div v-if="submitted && !movData.peso"
                             class="invalid-feedback">
                          <span>Campo peso obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="valor">Valor</label>
                      <div class="position-relative">
                        <input
                            id="valor"
                            type="number"
                            v-model="movData.valorliq"
                            class="form-control text-end"
                            :class="{'is-invalid': submitted && !movData.valorliq}"
                            placeholder="Valor"/>
                        <div v-if="submitted && !movData.valorliq"
                             class="invalid-feedback">
                          <span>Campo valor obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="altura">Altura (cm)</label>
                      <div class="position-relative">
                        <input
                            id="altura"
                            type="number"
                            v-model="movData.altura"
                            class="form-control text-end"
                            :class="{'is-invalid': submitted && !movData.altura}"
                            placeholder="Altura (cm)"/>
                        <div v-if="submitted && !movData.altura"
                             class="invalid-feedback">
                          <span>Campo altura obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="largura">Largura (cm)</label>
                      <div class="position-relative">
                        <input
                            id="largura"
                            type="number"
                            v-model="movData.largura"
                            class="form-control text-end"
                            :class="{'is-invalid': submitted && !movData.largura}"
                            placeholder="Largura (cm)"/>
                        <div v-if="submitted && !movData.largura"
                             class="invalid-feedback">
                          <span>Campo largura obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="comprimento">Comprimento(cm)</label>
                      <div class="position-relative">
                        <input
                            id="comprimento"
                            type="number"
                            v-model="movData.comprimento"
                            class="form-control text-end"
                            :class="{'is-invalid': submitted && !movData.comprimento}"
                            placeholder="Comprimento (cm)"/>
                        <div v-if="submitted && !movData.comprimento"
                             class="invalid-feedback">
                          <span>Campo comprimento obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="pesocub">Alt. x Larg. x Compr.</label>
                      <div class="position-relative">
                        <input
                            id="pesocub"
                            type="number"
                            v-model="movData.pesocub"
                            class="form-control text-end"
                            placeholder="Alt x Lar x Comp"/>
                      </div>
                    </div>

<!--                    <div class="col-md-2">-->
<!--                      <label for="ftcub">FT. Cub.</label>-->
<!--                      <div class="position-relative">-->
<!--                        <input-->
<!--                            id="ftcub"-->
<!--                            type="number"-->
<!--                            v-model="movData.ftcub"-->
<!--                            class="form-control text-end"-->
<!--                            :class="{'is-invalid': submitted && !movData.ftcub}"-->
<!--                            placeholder="Fator Cubagem"/>-->
<!--                        <div v-if="submitted && !movData.ftcub"-->
<!--                             class="invalid-feedback">-->
<!--                          <span>Campo fator cubagem obrigatório, favor preencher.</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->




                  </div>

                  <div class="row mt-4">

                    <b-form-checkbox
                        switch size="lg"
                        value="S"
                        unchecked-value="N"
                        v-model="paramTxAgenda"
                        @change="mudouParamTxAgenda"
                        class="form-check me-2 mt-0">
                      {{ paramTxAgenda === 'S' ? 'Confirmar Taxa de Agendamento' : 'Não Considerar Taxa de Agendamento' }}
                    </b-form-checkbox>


                  </div>





                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </form>
      </div>


      <div class="row">
        <div class="col-md-4" v-for="dataList in freteCotaInterData" :key="dataList.id">
          <div class="card" >
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted ms-5">
                        <h5 class="mb-1">Cotação {{ dataList['linhas']['id'] }} ({{ dataList['linhas']['transpnome'] }})</h5>
                        <p class="mb-0">{{ dataList['linhas']['cepini'] }} - {{ dataList['linhas']['cepfim'] }}</p>
                      </div>
                      <span class="float-end" style="z-index: 1000; position: absolute; top: 15px; left:15px;">
                        <div class="text-end">
                          <img
                              src="@/assets/images/logotransp/1234567891.png"
                              alt=""
                              class="avatar-sm rounded-circle img-thumbnail"
                          />
                        </div>
                      </span>
                    </div>
                    <a href="javascript: void(0);"
                       @click="abrirBase(dataList['linhas']['id'])"
                       class="ms-2">
                      Base
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </a>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-success" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal1'])" :key="data.seq">
                          <td class="text-end">{{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #1</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub1']) }}</td>
                        </tr>
                        <tr class="table-warning" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal2'])" :key="data.seq">
                          <td class="text-end"> {{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #2</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub2']) }}</td>
                        </tr>
                        <tr class="table-warning" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal3'])" :key="data.seq">
                          <td class="text-end"> {{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #3</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub3']) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #4</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub4']) }}</td>
                        </tr>
                        <tr class="table-info" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal4'])" :key="data.seq">
                          <td class="text-end"> {{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #5</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub5']) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #6</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimalQuatro(dataList['linhas']['totalsub6']) }}</td>
                        </tr>
                        <tr class="table-danger" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal5'])" :key="data.seq">
                          <td class="text-end"> {{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10"></td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="text-center">
                      <h5 class="mt-3">FRETE COMPARAÇÃO</h5>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-warning" v-for="data in dataList['linhas']['fretecomp']" :key="data.seq">
                          <th scope="row" class="text-end"> {{ data.seq }}</th>
                          <th scope="row" v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</th>
                          <th scope="row" v-else class="text-end"></th>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                          <td class="text-end">{{ formatDecimalQuatro(data.resultado) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="text-center">
                      <h5 class="mt-3">CUBAGEM</h5>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-warning" v-for="data in dataList['linhas']['cubagem']" :key="data.seq">
                          <th scope="row" class="text-end"> {{ data.seq }}</th>
                          <th scope="row" v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</th>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end"></td>
                          <td class="text-end">{{ formatDecimalQuatro(data.valor) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Prazo</p>
                        <h5 class="mb-0">{{ dataList['prazo'] }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Data de Entrega</p>
                        <h5 class="mb-0"> {{ formatDateMaisPrazo(new Date(), dataList['prazo']) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>






        <div class="col-md-4" v-for="dataList in freteCotaBraspData" :key="dataList.id">
          <div class="card" >
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted ms-5">
                        <h5 class="mb-1">Cotação {{ dataList['linhas']['id'] }} ({{ dataList['linhas']['transpnome'] }})</h5>
                        <p class="mb-0">{{ dataList['linhas']['cepini'] }} - {{ dataList['linhas']['cepfim'] }}</p>
                      </div>
                      <span class="float-end" style="z-index: 1000; position: absolute; top: 15px; left:15px; opacity: 0.8">
                        <div class="text-end">
                          <img
                              src="@/assets/images/logotransp/48740351000165.png"
                              alt=""
                              class="avatar-md rounded-circle img-thumbnail"
                          />
                        </div>
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-success" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal1'])" :key="data.seq">
                          <td class="text-end">{{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimal(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #1</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimal(dataList['linhas']['totalsub1']) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Prazo</p>
                        <h5 class="mb-0">{{ dataList['prazo'] }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Data de Entrega</p>
                        <h5 class="mb-0"> {{ formatDateMaisPrazo(new Date(), dataList['prazo']) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="col-md-4" v-for="dataList in freteCotaCorreiosData" :key="dataList.id">
          <div class="card" >
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted ms-5">
                        <h5 class="mb-1">Cotação {{ dataList['linhas']['id'] }} ({{ dataList['linhas']['transpnome'] }})</h5>
                        <p class="mb-0">{{ dataList['linhas']['cepini'] }} - {{ dataList['linhas']['cepfim'] }}</p>
                      </div>
                      <span class="float-end" style="z-index: 1000; position: absolute; top: 15px; left:15px; opacity: 0.8">
                        <div class="text-end">
                          <img
                              src="@/assets/images/logotransp/34028316001266.png"
                              alt=""
                              class="avatar-md rounded-circle img-thumbnail"
                          />
                        </div>
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-success" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal1'])" :key="data.seq">
                          <td class="text-end">{{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimal(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #1</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimal(dataList['linhas']['totalsub1']) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Prazo</p>
                        <h5 class="mb-0">{{ dataList['prazo'] }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Data de Entrega</p>
                        <h5 class="mb-0"> {{ formatDateMaisPrazo(new Date(), dataList['prazo']) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="col-md-4" v-for="dataList in freteCotaSSWData" :key="dataList.id">
          <div class="card" >
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted ms-5">
                        <h5 class="mb-1 ms-4">Cotação {{ dataList['linhas']['id'] }} ({{ dataList['linhas']['transpnome'] }})</h5>
                        <p class="mb-0">{{ dataList['linhas']['cepini'] }} - {{ dataList['linhas']['cepfim'] }}</p>
                      </div>
                      <span class="float-end" style="z-index: 1000; position: absolute; top: 15px; left:15px; opacity: 0.8">
                        <div class="text-end">
                          <img
                              src="@/assets/images/logotransp/01446320000132.png"
                              alt=""
                              class="avatar-md rounded-circle img-thumbnail"
                          />
                        </div>
                      </span>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-sm  mb-0">
                        <tbody>
                        <tr class="table-success" v-for="data in filtrarApenasValor(dataList['linhas']['subtotal1'])" :key="data.seq">
                          <td class="text-end">{{ data.seq }}</td>
                          <td v-if="data.valor > 0" class="text-end" :class="data.comp === '-' ? 'text-success' : 'text-danger'">({{ data.comp }})</td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimal(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #1</td>
                          <td class="text-black text-end font-size-14">{{ formatDecimal(dataList['linhas']['totalsub1']) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Prazo</p>
                        <h5 class="mb-0">{{ dataList['prazo'] }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Data de Entrega</p>
                        <h5 class="mb-0"> {{ formatDateMaisPrazo(new Date(), dataList['prazo']) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-4" v-if="freteCotaAzulData && freteCotaAzulData['linhas']">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted ms-5">
                        <h5 class="mb-1">
                          Cotação {{ freteCotaAzulData['linhas']['id'] }} ({{ freteCotaAzulData['linhas']['transpnome'] }})
                        </h5>
                        <p class="mb-0">{{ freteCotaAzulData['linhas']['cepini'] }} - {{ freteCotaAzulData['linhas']['cepfim'] }}</p>
                      </div>
                      <span class="float-end" style="z-index: 1000; position: absolute; top: 15px; left:15px; opacity: 0.8">
                <div class="text-end">
                  <img
                      src="@/assets/images/logotransp/316513216513.png"
                      alt=""
                      class="avatar-md rounded-circle img-thumbnail"
                  />
                </div>
              </span>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-sm mb-0">
                        <tbody>
                        <tr
                            class="table-success"
                            v-for="data in filtrarApenasValor(freteCotaAzulData['linhas']['subtotal1'])"
                            :key="data.seq"
                        >
                          <td class="text-end">{{ data.seq }}</td>
                          <td
                              v-if="data.valor > 0"
                              class="text-end"
                              :class="data.comp === '-' ? 'text-success' : 'text-danger'"
                          >
                            ({{ data.comp }})
                          </td>
                          <td v-else class="text-end"></td>
                          <td>{{ data.descricao }}</td>
                          <td class="text-end font-size-10">{{ formatDecimal(data.perc) }}%</td>
                          <td class="text-end">{{ formatDecimal(data.valor) }}</td>
                        </tr>
                        <tr class="table-light">
                          <td></td>
                          <td colspan="3" class="text-black text-end">SubTotal #1</td>
                          <td class="text-black text-end font-size-14">
                            {{ formatDecimal(freteCotaAzulData['linhas']['totalsub1']) }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Prazo</p>
                        <h5 class="mb-0">{{ freteCotaAzulData['prazo'] }}</h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-muted text-truncate mb-2">Data de Entrega</p>
                        <h5 class="mb-0">{{ formatDateMaisPrazo(new Date(), freteCotaAzulData['prazo']) }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>


    </div>


    <b-modal size="lg" title="Cotação Frete Correios" v-model="showModalCotarCorreios" centered hide-footer>
      <div class="card-body">
        <div class="row">

          <div class="col-md-6">
            <div class="mb-3">
              <span>Serviço</span>
              <multiselect id="servcorreios"
                           class="mt-2"
                           @search-change="pesqCorreioServico"
                           v-model="movData.servcorreios"
                           placeholder="Pesquisar serviços"
                           :options="dtListPesqCorreioServico"
                           :searchable="true"
                           label="descricao"
                           track-by="descricao"
                           :style="submittedCotarCorreios && !movData.servcorreios ? 'border: 1px solid #f86c6b !important;' : ''"
                           value-prop="codigo">
                <template #option="slotProps">
                  <div class="row">
                    <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                      <span class="mx-4" >
                          </span>
                    </div>
                    <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                    <span class="mx-4"></span>
                    <span class="mx-4"></span>
                    <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                  </div>
                </template>
              </multiselect>
              <div v-if="submittedCotarCorreios && !movData.servcorreios">
                <span class="text-danger font-size-11">Campo Serviço obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label for="prevpost">Data Postagem</label>
            <div class="position-relative">
              <input
                  id="prevpost"
                  type="date"
                  v-model="movData.prevpost"
                  class="form-control text-end"
                  placeholder="Data Postagem"
                  :class="{'is-invalid': submittedCotarCorreios && !movData.prevpost}"/>
              <div v-if="submittedCotarCorreios && !movData.prevpost" class="invalid-feedback">
                <span>Campo data postagem obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarCorreios = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="cotarCorreios">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Cotar Correios
          </b-button>
        </div>

      </div>
    </b-modal>

    <b-modal size="md" title="Selecionar tipo serviço Azul Cargo" v-model="showCotarAzulCargo" hide-footer>
      <div class="card-body">
        <div class="row">
          <b-form>
            <label for="tipo-servico" class="text-muted">Selecione o tipo do serviço Azul Cargo(por padrão - STANDARD)</label>
            <Multiselect
                id="tipo-servico"
                :maxSelectedLabels="1"
                v-model="selectedAzulCargoService"
                :options="serviceAzulCargoOptions"
                placeholder="Selecione o tipo do serviço"
                class="text-primary mb-3"
            >
            </Multiselect>

            <!-- DEFINIÇÃO SE MERCADORIA SERÁ IN-LOCO  -->
            <label for="tipo-entrega" class="text-muted">Selecione o tipo de entrega(por padrão - DOMICÍLIO)</label>
            <Multiselect
                id="tipo-entrega"
                :maxSelectedLabels="1"
                v-model="selectedTipoEntregaAzul"
                :options="tipoEntregaAzul"
                placeholder="Selecione o tipo de entrega"
                class="text-primary mb-3"
            >
            </Multiselect>

            <!-- DEFINIÇÃO SE HAVERÁ COLETA  -->
            <label for="tipo-entrega" class="text-muted">Indicador de coleta(por padrão será SIM)</label>
            <Multiselect
                id="tipo-servico"
                :maxSelectedLabels="1"
                v-model="selectedColetaAzul"
                :options="['SIM', 'NÃO']"
                placeholder="Selecione o tipo do indicador de coleta"
                class="text-primary mb-3"
            >
            </Multiselect>

            <div class="d-flex justify-content-center">
              <b-button variant="info" class="mt-5" @click="cotarAzulCargo">Cotar</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>
